module.exports = __webpack_public_path__ + "img/图片6.b18c707d.png";